import React, { createContext, useState, ReactNode } from 'react';
import { CustomTagProps } from 'types/CustomTagProps';
import { PaginationProps } from 'types/PaginationProps';

const pagesInitial = {
  limit: 10,
  page: 1,
  total: 0,
  totalPages: 0,
};

interface CustomTagContextProps {
  tags: CustomTagProps[];
  setTags: React.Dispatch<React.SetStateAction<CustomTagProps[]>>;
  isReq: boolean;
  setIsReq: React.Dispatch<React.SetStateAction<boolean>>;
  isFormOpen: boolean;
  setIsFormOpen: React.Dispatch<React.SetStateAction<boolean>>;
  isEdit: boolean;
  setIsEdit: React.Dispatch<React.SetStateAction<boolean>>;
  itemToEdit: CustomTagProps | null;
  setItemToEdit: React.Dispatch<React.SetStateAction<CustomTagProps | null>>;
  pagesData: PaginationProps;
  setPagesData: React.Dispatch<React.SetStateAction<PaginationProps>>;
}

const CustomTagContext = createContext<CustomTagContextProps>({
  tags: null,
  setTags: () => {},
  isReq: false,
  setIsReq: () => {},
  isFormOpen: false,
  setIsFormOpen: () => {},
  isEdit: false,
  setIsEdit: () => {},
  itemToEdit: null,
  setItemToEdit: () => {},
  pagesData: pagesInitial,
  setPagesData: () => {},
});

interface ContextProps {
  children: ReactNode;
}

export function CustomTagProvider({ children }: ContextProps) {
  const [tagsList, setTagList] = useState<CustomTagProps[]>([]);
  const [tagToEdit, setTagToEdit] = useState<CustomTagProps | null>(null);
  const [isReqTags, setIsReqTags] = useState(false);
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [pages, setPages] = useState<PaginationProps>(pagesInitial);

  return (
    <CustomTagContext.Provider
      value={{
        tags: tagsList,
        setTags: setTagList,
        isReq: isReqTags,
        setIsReq: setIsReqTags,
        isFormOpen,
        setIsFormOpen,
        isEdit,
        setIsEdit,
        itemToEdit: tagToEdit,
        setItemToEdit: setTagToEdit,
        pagesData: pages,
        setPagesData: setPages,
      }}
    >
      {children}
    </CustomTagContext.Provider>
  );
}

export default CustomTagContext;
